import { useGetModificationsQuery } from '@carboncopyco/data';

interface Props {
  organizationId: string;
  demoId: string;
}

export const useGuidedSandboxModifications = ({
  organizationId,
  demoId,
}: Props) => {
  const { data: modifications } = useGetModificationsQuery(
    {
      organizationId,
      entityType: 'demo',
      entityId: String(demoId),
      apiVersion: 2,
    },
    { skip: !demoId, refetchOnMountOrArgChange: true }
  );

  const guidanceTooltips =
    modifications?.filter(
      (modification) => modification.modificationType === 'tooltip'
    ) || [];

  return {
    guidanceTooltips,
  };
};
